// extracted by mini-css-extract-plugin
export default {"infoSection":"infoSection__N2ZkM","icon":"icon__NmY3Y"};